import React, { type ReactNode } from 'react';
type MockWindowProps = {
  children: ReactNode;
  bar?: ReactNode;
  className?: string;
};

/** A simplified browser window that frames each Stripe screen mockup. */
export function MockWindow({
  children,
  bar,
  className = ''
}: MockWindowProps) {
  return <div className={`w-full border-2 border-mm-charcoal bg-mm-white font-body shadow-[0.6cqw_0.6cqw_0_0_rgba(34,34,34,0.12)] ${className}`} data-id="element-119" data-mp="3cpcw3d3kmrct">
      <div className="flex items-center gap-[1cqw] border-b border-mm-light-gray bg-[#F1F1EE] px-[1cqw] py-[0.7cqw]" data-id="element-120" data-mp="4a2vyaj8rw7o">
        <div className="flex gap-[0.4cqw]" aria-hidden="true" data-id="element-121" data-mp="9aql0qnwu2z9">
          <span className="h-[0.6cqw] w-[0.6cqw] bg-mm-light-gray" data-id="element-122" data-mp="3qo46opj85uw7" />
          <span className="h-[0.6cqw] w-[0.6cqw] bg-mm-light-gray" data-id="element-123" data-mp="3vnyxkt302kh9" />
          <span className="h-[0.6cqw] w-[0.6cqw] bg-mm-light-gray" data-id="element-124" data-mp="3vm5l2x5ph61c" />
        </div>
        {bar}
      </div>
      {children}
    </div>;
}